// ADDED
import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useClinicRequirements } from "../../hooks/useClinicRequirements";
import ClinicRequirementsModule from "../../components/modules/ClinicRequirements/ClinicRequirementsModule";

const ClinicRequirementsPage = ({ user, isHideSideMenu }) => {
  const reqMethods = useClinicRequirements();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Clinic Requirements"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Clinic Requirements</h3>
            </div>

            <ClinicRequirementsModule
              user={user}
              {...reqMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={reqMethods.showMessage}
        message={reqMethods.message}
        isSuccess={reqMethods.isSuccess}
      />

      <LoadingSpinner loading={reqMethods.loading} />
    </>
  );
};

export default ClinicRequirementsPage;